import React from 'react';
import { Icon, Text, useIsMobile } from '@amzn/storm-ui';
import styled from 'styled-components';
import { useAccountDropdownBundle } from 'src/providers/PantherLocalizationProvider';
import { useIsRTL } from 'src/commons/hooks';

export const ErrorLoadingAccountsContainer = styled.div<{ isMobile: boolean }>`
  display: flex;
  padding: ${({ theme }) =>
    `${theme.spacing.xsmall.default} ${theme.spacing.base.default}`};
  justify-content: center;
`;

const StyledText = styled(Text)`
  display: flex;
`;

const WarningIcon = styled(Icon)<{ isRtl: boolean }>`
  color: ${({ theme }) => theme.color.orange[500]};
  margin-inline-end: ${({ theme }) => theme.spacing.xxsmall.default};
`;

export const ErrorLoadingAccountsMessage: React.VFC = () => {
  const bundle = useAccountDropdownBundle();
  const isRtl = useIsRTL();
  const isMobile = useIsMobile();

  return (
    <ErrorLoadingAccountsContainer isMobile={isMobile ?? false}>
      <StyledText color="secondary" size="xsmall">
        <WarningIcon type="exclamation-triangle" isRtl={isRtl} />
        {bundle.getMessage('account-dropdown-error-loading-accounts')}
      </StyledText>
    </ErrorLoadingAccountsContainer>
  );
};
